import Loader from 'utils/Loader';
import { Box, Grid, TextField, ClickAwayListener, Button } from '@mui/material';
import BeatPlanningController from '../Controller/BeatPlanningController';
import { DateRange } from 'react-date-range';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';

const BeatPlanning = () => {
    const { cloading,
    beats,
    showCalendar,
    setShowCalendar,
    selectedBeats,
    range,
    setRange,
    toggleBeat,
    handleSubmit } = BeatPlanningController();
   


    return (
        <div className="bg" style={{ display: 'block', padding: '20px' }}>
            {cloading && (
                <div className="overlay">
                    <Loader />
                    <span style={{ marginLeft: '10px' }}>Please Wait....</span>
                </div>
            )}

            <div className="cutrange">
                <span className="font20">BEAT PLANNING</span>
            </div>

            {/* Date Range Picker */}
            <Box sx={{ display: 'flex', justifyContent: 'center', marginBottom: 5, position: 'relative' }}>
                <TextField
                    style={{
                        width: '250px',
                        maxWidth: '90%',
                        backgroundColor: 'white',
                        borderRadius: '4px',
                        cursor: 'pointer',
                    }}
                    value={`${range[0].startDate.toLocaleDateString()} - ${range[0].endDate.toLocaleDateString()}`}
                    onClick={() => setShowCalendar(!showCalendar)}
                    readOnly
                    fullWidth
                    InputProps={{ style: { textAlign: 'center' } }}
                />

                {showCalendar && (
                    <ClickAwayListener onClickAway={() => setShowCalendar(false)}>
                        <Box
                            sx={{
                                position: 'absolute',
                                top: '100%',
                                left: '50',
                                zIndex: 9999,
                                boxShadow: 3,
                                mt: 0.5,
                            }}
                        >
                            <DateRange
                                editableDateInputs={true}
                                onChange={item => {
                                    setRange([item.selection]);
                                    setShowCalendar(false);
                                }}
                                moveRangeOnFirstSelection={false}
                                ranges={range}
                                minDate={new Date()}
                            />
                        </Box>
                    </ClickAwayListener>
                )}
            </Box>

            {/* Beats List */}
            {beats.length === 0 ? (
                <Box sx={{ textAlign: 'center', marginTop: 2, color: 'white'  }}>No Beats Assigned!</Box>
            ) : (
                <Grid container spacing={3}>
                    {beats.map((beat, index) => {
                        const isSelected = selectedBeats.includes(beat.beat_code);
                        return (
                            <Grid item xs={12} sm={4} md={2} xl={2} key={index}>
                                <Box
                                    onClick={() => toggleBeat(beat.beat_code)}
                                    sx={{
                                        backgroundColor: isSelected ? '#f28b82' : 'white',
                                        color: isSelected ? 'white' : 'black',
                                        borderRadius: 2,
                                        padding: 1,
                                        textAlign: 'center',
                                        cursor: 'pointer',
                                        border: isSelected ? '2px solid #f28b82' : '1px solid #ccc',
                                        transition: 'all 0.2s'
                                    }}
                                >
                                    <h3 style={{color: 'black'}}>{beat.beat_code}</h3>
                                </Box>
                            </Grid>
                        );
                    })}
                </Grid>
            )}

            {/* Submit Button */}
            <div className="sticky bottom-0 border-t p-0">
            <Box sx={{ display: 'flex', justifyContent: 'center', marginTop: 4 }}>
                <Button
                    variant="contained"
                    color="primary"
                    onClick={handleSubmit}
                    disabled={selectedBeats.length === 0}
                    sx={{
            width: '250px',
            color: 'white',      // font color
            fontSize: '20px',    // font size
        }}
                >
                    Submit
                </Button>
            </Box>
            </div>
        </div>
    );
};

export default BeatPlanning;
